import * as React from 'react'


export default class Footer extends React.PureComponent<{
  onClickPrivacy: () => void
  onClickFTC: () => void
}, {}> {
  render() {
    return (
      <div className="footer">
        
        <div className="footer-left">
          Supported by <a href="https://designbombs.com" target="_blank">DesignBombs</a>
        </div>

        <div className="footer-right">
          <a href="#" onClick={this.props.onClickPrivacy}>Privacy Policy</a>
          <span className="footer-nav-sep">-</span>
          <a href="#" onClick={this.props.onClickFTC}>FTC Disclosure</a>
          <span className="footer-nav-sep">-</span>
          <a href="https://www.designbombs.com/contact/" target="_blank">Contact</a>
        </div>

      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/comp/footer.tsx